import React, { useCallback } from 'react';
import styles from './Support.module.scss';
import Box from '@/components/UI/box/Box';
import { configData } from '@/helpers/config';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import Typography from '@/components/UI/typography/Typography';
import Link from 'next/link';
const Support = () => {
  const handleGoftino = useCallback(() => {
    if ((window as any).isGoftinoReady) {
      ;
      (window as any).Goftino.open();
    }
  }, []);
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="Support" data-sentry-source-file="Support.tsx">
      <Box className={styles['wrapper']} data-sentry-element="Box" data-sentry-source-file="Support.tsx">
        <Box className={styles['titles']} data-sentry-element="Box" data-sentry-source-file="Support.tsx">
          <Typography component={'h5'} variant={'title'} data-sentry-element="Typography" data-sentry-source-file="Support.tsx">
            تلفن پشتیبانی
          </Typography>
          <Typography variant={'bodyM'} data-sentry-element="Typography" data-sentry-source-file="Support.tsx">پاسخگویی از 8 صبح الی 12 شب</Typography>
        </Box>
        <Link className={styles['phone-number']} href={`tel:${configData.footerSupportNumber}`} data-sentry-element="Link" data-sentry-source-file="Support.tsx">
          <Typography component={'h4'} variant={'headlineL'} data-sentry-element="Typography" data-sentry-source-file="Support.tsx">
            {configData.footerSupportNumberShow}
          </Typography>
          <Box className={styles['icon-container']} data-sentry-element="Box" data-sentry-source-file="Support.tsx">
            <Icon type={'primary'} name={'call-Filled'} size={'large'} data-sentry-element="Icon" data-sentry-source-file="Support.tsx" />
          </Box>
        </Link>
        {/* <Link
          className={styles['phone-number']}
          href={`tel:${configData.footerZibalNumber}`}
         >
          <Typography component={'h4'} variant={'headlineL'}>
            {configData.footerZibalNumberShow}
          </Typography>
          <Box className={styles['icon-container']}>
            <Icon type={'primary'} name={'call-Filled'} size={'large'} />
          </Box>
         </Link> */}

        <Box className={styles['support-button']} data-sentry-element="Box" data-sentry-source-file="Support.tsx">
          <Button format="primary" onClick={handleGoftino} data-sentry-element="Button" data-sentry-source-file="Support.tsx">
            چت با پشتیبانی
          </Button>
        </Box>
      </Box>
    </Box>;
};
export default Support;